<template>
  <v-dialog v-model="imageDialog" max-width="400">
    <v-card>
      <v-card-title class="text-h5">
        Informe a URL da Imagem
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-text-field
          v-model="imageContent"
          variant="outlined"
          label="URL da Imagem"
          type="url"
          class="mt-4"
          color="primary"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          size="small"
          variant="text"
          @click="close"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          size="small"
          variant="text"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({

  emits: ['close', 'save'],

  setup(props, { emit }) {
    const imageContent = ref('')
    const imageDialog = ref(true)
    const close = () => {
      imageDialog.value = false
      emit('close')
    }
    const save = () => {
      imageDialog.value = false
      emit('save', {
        src: imageContent.value,
      })
    }
    return {
      imageContent,
      imageDialog,
      close,
      save,
    }
  },
})
</script>
